// Functions for generating CSV from a DataFrame.
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    downloadCSV: function() {
        return _download.downloadCSV;
    },
    escapeCSV: function() {
        return escapeCSV;
    },
    formatTraceIdAsQuery: function() {
        return formatTraceIdAsQuery;
    },
    removeSpecialTraces: function() {
        return removeSpecialTraces;
    },
    dataframeToCSV: function() {
        return dataframeToCSV;
    },
    traceSeriesToCSV: function() {
        return traceSeriesToCSV;
    }
});
const _const = require("../const/const");
const _json = require("../json");
const _paramtools = require("../paramtools");
const _download = require("./download");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function escapeCSV(val) {
    if (val.includes(',') || val.includes('"') || val.includes('\n') || val.includes('\r')) {
        return `"${val.replace(/"/g, '""')}"`;
    }
    return val;
}
function formatTraceIdAsQuery(traceId) {
    const params = (0, _paramtools.fromKey)(traceId);
    const keys = Object.keys(params).sort();
    if (keys.length === 0) {
        return traceId;
    }
    return keys.map((k)=>`${k}=${params[k]}`).join('&');
}
function removeSpecialTraces(data) {
    if (!data) {
        return data;
    }
    if (Array.isArray(data)) {
        return data.filter((s)=>{
            var _s_id;
            return !((_s_id = s.id) === null || _s_id === void 0 ? void 0 : _s_id.startsWith('special_'));
        });
    }
    if (data.traceset) {
        const filteredMap = {};
        for (const [key, val] of Object.entries(data.traceset)){
            if (!key.startsWith('special_') && key !== '_traceSetBrand') {
                filteredMap[key] = val;
            }
        }
        return _object_spread_props(_object_spread({}, data), {
            traceset: (0, _json.TraceSet)(filteredMap)
        });
    }
    return data;
}
function dataframeToCSV(df) {
    if (!df || !df.header || !df.traceset) {
        return '';
    }
    const traceIds = Object.keys(df.traceset);
    if (traceIds.length === 0) {
        return '';
    }
    // Build CSV Header
    const headerRow = [
        'offset',
        'hash'
    ];
    for (const id of traceIds){
        const formatted = formatTraceIdAsQuery(id);
        headerRow.push(escapeCSV(formatted));
    }
    const csv = [
        headerRow.join(',')
    ];
    // Build CSV Rows per commit
    const numCommits = df.header.length;
    for(let i = 0; i < numCommits; i++){
        const colHeader = df.header[i];
        if (!colHeader) {
            continue;
        }
        const offsetStr = colHeader.offset !== undefined && colHeader.offset !== null ? `${colHeader.offset}` : '';
        const hashStr = colHeader.hash || '';
        const rowValues = [
            escapeCSV(offsetStr),
            escapeCSV(hashStr)
        ];
        for (const id of traceIds){
            const trace = df.traceset[id];
            const val = trace ? trace[i] : undefined;
            if (val === undefined || val === _const.MISSING_DATA_SENTINEL || isNaN(val) || val === null) {
                rowValues.push('');
            } else {
                rowValues.push(`${val}`);
            }
        }
        csv.push(rowValues.join(','));
    }
    return csv.join('\n');
}
function traceSeriesToCSV(series) {
    if (!series || series.length === 0) {
        return '';
    }
    const activeSeries = series.filter((s)=>!s.hidden && s.rows && s.rows.length > 0);
    if (activeSeries.length === 0) {
        return '';
    }
    // Collect all unique commit_numbers and any associated hash across all series.
    const commitMap = new Map();
    for (const s of activeSeries){
        for (const row of s.rows){
            if (row.commit_number !== undefined && row.commit_number !== null) {
                if (!commitMap.has(row.commit_number) || !commitMap.get(row.commit_number) && row.hash) {
                    commitMap.set(row.commit_number, row.hash || '');
                }
            }
        }
    }
    const sortedCommits = Array.from(commitMap.keys()).sort((a, b)=>a - b);
    if (sortedCommits.length === 0) {
        return '';
    }
    // Pre-index series rows by commit_number for fast lookup
    const seriesRowMaps = activeSeries.map((s)=>{
        const map = new Map();
        for (const row of s.rows){
            map.set(row.commit_number, row.val);
        }
        return map;
    });
    // Header row
    const headerRow = [
        'offset',
        'hash'
    ];
    for (const s of activeSeries){
        headerRow.push(escapeCSV(formatTraceIdAsQuery(s.id)));
    }
    const csv = [
        headerRow.join(',')
    ];
    // Data rows
    for (const commit of sortedCommits){
        const hash = commitMap.get(commit) || '';
        const rowValues = [
            escapeCSV(`${commit}`),
            escapeCSV(hash)
        ];
        for(let i = 0; i < activeSeries.length; i++){
            const val = seriesRowMaps[i].get(commit);
            if (val === undefined || val === _const.MISSING_DATA_SENTINEL || isNaN(val) || val === null) {
                rowValues.push('');
            } else {
                rowValues.push(`${val}`);
            }
        }
        csv.push(rowValues.join(','));
    }
    return csv.join('\n');
}
